import { useCallback, useState } from 'react';
import { AuthUser, generateMagicLink, refreshTokens } from '../services/auth';
import { appUrl } from '../services/navigation';
import { openExternal } from '../services/externalLink';

/** Opens the team's billing page in the browser, authenticated via a magic link. */
export function useUpgradeNavigation(
  user: AuthUser | null,
  onAuthChange: (user: AuthUser | null) => void,
) {
  const [loading, setLoading] = useState(false);

  const handleUpgradeClick = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const freshUser = await refreshTokens(user, onAuthChange);
      if (!freshUser) return;
      const destination = appUrl('settings/billing-and-payment');
      const magicLinkUrl = await generateMagicLink(freshUser.accessToken);
      openExternal(`${magicLinkUrl}?returnUrl=${encodeURIComponent(destination)}`);
    } finally {
      setLoading(false);
    }
  }, [user, onAuthChange]);

  return { handleUpgradeClick, upgradeLoading: loading };
}
